var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Header from "@containers/common/header";
import { mainRouterList, residentScheduleOptimizationList } from "./config";
import Theme from "@containers/common/theme";
import { inject } from "mobx-react";
import { ShareBusiness } from "@business/common/share";
import "./mainLayout.less";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { initFavicon, isDisableMenuBar } from "@common/utils";
import { HeaderBusiness } from "@business/common/header";
import { combine } from "fe-toolkit";
import TagManager from 'react-gtm-module';
import CopilotIndex from "@containers/common/copilotIndex";
var MainLayout = /** @class */ (function (_super) {
    __extends(MainLayout, _super);
    function MainLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainLayout.prototype.componentDidMount = function () {
        var initShareData = this.props.initShareData;
        if (!residentScheduleOptimizationList.some(function (x) { return location.href.toLowerCase().includes(x.path.toLowerCase()); })) {
            initShareData();
            initFavicon();
            this.listenPage();
        }
    };
    MainLayout.prototype.shouldComponentUpdate = function (prevProps) {
        var location = this.props.location;
        return location.pathname !== prevProps.location.pathname || location.search !== prevProps.location.search;
    };
    MainLayout.prototype.listenPage = function () {
        var tagManagerArgs = {
            gtmId: 'GTM-5NHMF7N'
        };
        TagManager.initialize(tagManagerArgs);
        console.log('gtm init');
    };
    MainLayout.prototype.render = function () {
        var _a = this.props, location = _a.location, needCopilotFixedButton = _a.needCopilotFixedButton;
        return (React.createElement("div", { className: "body_wrapper" },
            React.createElement(Theme, null,
                React.createElement(Header, null),
                React.createElement(CSSTransitionGroup, { component: "div", className: "transition-group " + (isDisableMenuBar() ? 'main-bt-0' : ''), transitionName: "fade", transitionEnter: true, transitionLeave: true, transitionEnterTimeout: 250, transitionLeaveTimeout: 250 },
                    React.createElement(Switch, { key: location.pathname, location: location },
                        mainRouterList.map(function (config) { return (React.createElement(Route, { exact: true, key: config.path, path: config.path, component: config.component, title: config.title })); }),
                        React.createElement(Route, { key: "unmatch", component: function () { return React.createElement(Redirect, { to: "/" }); } })),
                    needCopilotFixedButton && React.createElement(CopilotIndex, { needFixedButton: true })))));
    };
    MainLayout = __decorate([
        inject(combine(ShareBusiness, HeaderBusiness))
    ], MainLayout);
    return MainLayout;
}(React.Component));
export default MainLayout;
